import type { ComponentProps } from "react";
import { FinancialDocumentsViewContainer } from "@components/documents/FinancialDocumentsView/FinancialDocumentsViewContainer";
import { useFinancialDocumentRowChatDrag } from "./useFinancialDocumentRowChatDrag";

/**
 * The task's documents table with rows draggable into the task chat. Renders
 * inside `FinancialDocumentsTaskTableProvider`, which holds the selection.
 */
export const FinancialDocumentsTaskViewContainer = (
    props: ComponentProps<typeof FinancialDocumentsViewContainer>,
) => {
    const rowDragOut = useFinancialDocumentRowChatDrag();
    return (
        <FinancialDocumentsViewContainer {...props} rowDragOut={rowDragOut} />
    );
};
